import { jsx as _jsx } from "react/jsx-runtime";
import { WarningOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react";
import { AffiliateStatePanel } from "./affiliateStatePanel.js";
import { __ } from "../../../../../../utils/i18n.js";
const AffiliateSignupErrorState = observer(({ error })=>/*#__PURE__*/ _jsx(AffiliateStatePanel, {
        tone: "warning",
        icon: /*#__PURE__*/ _jsx(WarningOutlined, {}),
        heading: __("There's a problem with your affiliate account"),
        action: /*#__PURE__*/ _jsx(Button, {
            type: "primary",
            href: "mailto:support@devowl.io",
            children: __("Contact support")
        }),
        children: error.message
    }));
export { AffiliateSignupErrorState };
